export enum eEntityType {
  corporation = 'corporation',
  estate = 'estate',
  joint_venture = 'joint_venture',
  llc = 'llc',
  non_profit_corporation = 'non_profit_corporation',
  partnership = 'partnership',
  trust = 'trust',
  other = 'other',
}

export const DisplayEntityType = {
  [eEntityType.corporation]: 'Corporation',
  [eEntityType.estate]: 'Estate',
  [eEntityType.joint_venture]: 'Joint Venture',
  [eEntityType.llc]: 'LLC',
  [eEntityType.non_profit_corporation]: 'Non-Profit Corporation',
  [eEntityType.partnership]: 'Partnership',
  [eEntityType.trust]: 'Trust',
  [eEntityType.other]: 'Other',
};
